var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subfolder"},[_c('FolderData',{ref:"folderData",attrs:{"folder-id":_vm.folderId || '0',"folder-loading":_vm.loading,"folder-notfound":_vm.notFound,"folder-error":_vm.error,"select-all":_vm.selectAll}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }